import { useDetailHub } from "hooks/hub-management/useHub";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import DetailForm from "../updateHub/DetailForm";

const DetailHub = ({ isOpenModal, toggleModal, hubId }) => {
  const { t } = useTranslation(["hub"]);
  const {
    isLoading,
    data: hubDetail,
    refetch: refetchHubDetail,
  } = useDetailHub({
    hubId,
    params: {
      expand: "province_name,district_name,ward_name,parent_hub",
    },
  });

  useEffect(() => {
    if (hubId && isOpenModal) {
      refetchHubDetail();
    }
  }, [hubId, isOpenModal]);

  console.log("hubDetail", hubDetail);

  return (
    <Modal
      size="xl"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggleModal}
    >
      <ModalHeader toggle={toggleModal}>{t("title.detail")}</ModalHeader>
      <ModalBody>
        <DetailForm viewMode detail={hubDetail} />
      </ModalBody>
    </Modal>
  );
};

export default DetailHub;
